import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { CanonicalService } from 'src/app/services/canonical.service';
import { PrivacyInfo, PrivacyInfoService, PrivacyProcessor, RETENTION_UNITS, RetentionKey } from 'src/app/services/privacy-info.service';

// Page légale en français uniquement (texte faisant foi, comme les mentions légales). Responsable, durées de
// conservation et prestataires viennent du back office (Administration → Privacy (GDPR)) : ne pas les écrire en dur ici.
@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {

  readonly info$: Observable<PrivacyInfo>;

  constructor(
    private title: Title,
    private metaTagService: Meta,
    private canonicalService: CanonicalService,
    privacyInfoService: PrivacyInfoService,
  ) {
    this.info$ = privacyInfoService.info$;
  }

  ngOnInit(): void {
    this.canonicalService.setCanonicalURL();
    this.title.setTitle("Politique de confidentialité et de protection de la vie privée - promodeep.com");
    this.metaTagService.updateTag (
      { name:"description", content:"➤ Données collectées par PromoDeep, finalités, durées de conservation, prestataires et vos droits (accès, suppression, opposition) - promodeep.com"},
    );
  }

  // « 36 mois (3 ans) », « 30 jours »
  duration(info: PrivacyInfo, key: RetentionKey): string {
    const value = info.retention[key];
    if (RETENTION_UNITS[key] === 'days') {
      return `${value} jour${value > 1 ? 's' : ''}`;
    }
    const years = value % 12 === 0 ? value / 12 : 0;
    return `${value} mois` + (years ? ` (${years} an${years > 1 ? 's' : ''})` : '');
  }

  processorsByRole(info: PrivacyInfo, role: PrivacyProcessor['role']): PrivacyProcessor[] {
    return info.processors.filter(p => p.role === role);
  }
}
